export enum MenuGroupEnum {
    SMS = 'SMS',
    WHATSAPP = 'Whatsapp'
}
